<template>
	<div class="loading-root">
		<img class="loading-bg" src="@/assets/annualReport/loadingBg.jpg" alt="" />
		<img
			class="loading-img"
			src="@/assets/annualReport/coffeeMachine.png"
			alt=""
		/>
		<div class="loading-info">
			<div class="loading-message">正在萃取您的年度经营数据...</div>
			<div class="percent">{{ percent }}%</div>
		</div>
		<div class="loading-bottom-message">
			数据仅包含库迪咖啡小程序和APP大陆地区数据, <br />
			统计日期为2025年1月1日-2025年12月20日24:00
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Loading',
		props: {
			isLoading: {
				type: Boolean,
				required: false
			}
		},
		data() {
			return { 
				percent: 0,
				minLoadTime: 1500, // 最小加载时间 3 秒
				startTime: 0,
				apiFinished: false,
				progressInterval: null
			};
		},
		mounted() {

		},
		watch: {
			isLoading(newVal) {
				if (newVal) {
					this.startTime = Date.now();
					this.simulateLoad();
				}
			}
		},
		methods: {
			simulateLoad() {
				const run = () => {
					if (this.percent >= 99) return;
					
					// 随机增量 1-10,让进度条在 99% 之前相对慢一些
					const inc = Math.floor(Math.random() * 10) + 1;
					const next = this.percent + inc;

					if (next >= 99) {
						this.percent = 99;
						// 到 99% 后等待接口完成和最小时间
						this.checkAndFinish();
					} else {
						this.percent = next;
						// 随机间隔时间 10-110ms
						this.progressInterval = setTimeout(run, 10 + Math.random() * 100);
					}
				};
				run();
			},
			onApiFinished() {
				this.apiFinished = true;
				if (this.percent >= 99) {
					this.checkAndFinish();
				}
			},
			checkAndFinish() {
				const elapsed = Date.now() - this.startTime;
				const remaining = Math.max(0, this.minLoadTime - elapsed);
				
				if (this.apiFinished && remaining === 0) {
					// 接口完成且已经超过 3 秒,立即结束
					this.finish();
				} else if (this.apiFinished) {
					// 接口完成但未到 3 秒,等待剩余时间
					setTimeout(() => this.finish(), remaining);
				} else if (remaining === 0) {
					// 已超过 3 秒但接口未完成,等待接口
					// 不做任何操作,等待 onApiFinished 被调用
				} else {
					// 都未完成,继续等待
					setTimeout(() => this.checkAndFinish(), 100);
				}
			},
			finish() {
				this.percent = 100;
				setTimeout(() => this.$emit("done"), 300);
			}
		},
		beforeDestroy() {
			if (this.progressInterval) {
				clearTimeout(this.progressInterval);
			}
		}
	};
</script>

<style lang="scss" scoped>
	.loading-root {
		height: 100vh;
		.loading-bg {
			position: absolute;
			width: 100%;
			height: 100vh;
			top: 0;
			left: 0;
			z-index: -1;
		}
		.loading-img {
			margin-top: 50%;
			width: 100%;
			height: 389px;
		}
		.loading-info {
			margin-top: -30px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}
		.loading-message {
			height: 27px;
			font-family: "MontserratRoman-SemiBold";
			font-weight: 500;
			font-size: 28px;
			color: #94573b;
			text-align: center;
		}
		.percent {
			font-family: "MontserratRoman-SemiBold";
			font-weight: 600;
			font-size: 56px;
			color: #94573b;
			text-align: center;
			margin-top: 15px;
		}
		.loading-bottom-message{
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			bottom: 124px;
			text-align: center;
			
			font-weight: 400;
			font-size: 16px;
			color: rgba($color: #000000, $alpha: 0.8);
			line-height: 24px;
		}
	}
</style>
